import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import React, {useEffect, useState} from "react";
import SpotifyUserForm from "./SpotifyUserForm";
import {UserService} from "../services/UserService";

export default function SpotifyUsers({spotifyUsers, setSpotifyUsers, connectSpotifyAccount, spotifyAppOptions}) {
    const [expandedRows, setExpandedRows] = useState(null);
    const userservice = new UserService();
    //const spotifyAppOptions = spotifyApps.map((data) => { {'spotifyapp_id': data.id, 'displayname': data.displayname}})



    let emptyUser = {
        id: '',
        spotify_name: '',
        spotify_email: '',
        spotifyapp_id: null,
    };

    const [userDialog, setUserDialog] = useState(false);
    const [newUser, setNewUser] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const openNew = () => {
        setNewUser(emptyUser);
        setSubmitted(false);
        setUserDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setUserDialog(false);
    }

    const editUser = (user) => {
        setNewUser(user);
        setUserDialog(true);
    }

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < spotifyUsers.length; i++) {
            if (spotifyUsers[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    const addNewToUsers = (isNew, user) => {
        let _users = [...spotifyUsers];
        if (isNew) {
            _users.push(user);
        } else {
            let i = findIndexById(user.id);
            _users[i] = user;
        }
        setSpotifyUsers(_users);
        setUserDialog(false);
        setNewUser(emptyUser);
    };

    const rowExpansionTemplate = (data) => {
        return (
            <div className="p-3">
                <h5>Spotify Users connected to {data.displayname}</h5>
                <DataTable value={data.spotify_users}>
                    <Column field="spotify_name" header="Display Name" sortable></Column>
                    <Column field="spotify_email" header="email"></Column>
                </DataTable>
            </div>
        );
    };
    //<Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteProduct(rowData)} />
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded mr-2"
                        onClick={() => editUser(rowData)}/>
            </React.Fragment>
        );
    }

    const linkBodyTemplate = (data) => {
        if(data.spotify_id){
            return <div>
                <Button icon="pi pi-external-link" className="p-button-rounded bg-spot" aria-label="OpenSpotifyProfileNewTab" onClick={() => {
                    let win = window.open(('https://open.spotify.com/user/' + data.spotify_id), '_blank');
                    win.focus();
                }} label={"Profile"}/>
            </div>;
        } else {
            return <div>no spotify profile linked yet</div>;
        }
    };

    const spotifyAppTemplate = (data) => {
        if(data.spotifyapp_id){
            return <i className="pi pi-check" style={{ color: 'green' }}></i>
        }
        else {
            return <i className="pi pi-times" style={{ color: 'red' }}></i>
        }
    }

    const connectBodyTemplate = (data) => {
        if(data.is_connected){
            return <div><span className={"pi pi-verified"}/></div>
        }else {
            return <div><Button label="Connect Spotify Account" onClick={()=>connectSpotifyAccount(data.id)}/></div>
        }
    }

    return (<div>
            <Button label="New" icon="pi pi-plus" className="mr-2" onClick={openNew}/>

            <DataTable value={spotifyUsers}
                       dataKey="id">
                <Column field="spotify_name" header="Name"/>
                <Column field="spotify_email" header="Spotify eMail"/>
                <Column body={spotifyAppTemplate} field="spotifyapp_id" header="Spotify App"/>
                <Column body={linkBodyTemplate} field="spotify_id" header="Profile Link" />
                <Column body={actionBodyTemplate} exportable={false} ></Column>
                <Column body={connectBodyTemplate} exportable={false} ></Column>
            </DataTable>
            <Dialog visible={userDialog} style={{width: '450px'}} header="Spotify User" modal
                    className="p-fluid" onHide={hideDialog}>
                <SpotifyUserForm onSaveUser={addNewToUsers} newUser={newUser} spotifyAppOptions={spotifyAppOptions}/>
            </Dialog>
        </div>

    )
}